import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const storedUser = () => {
  const user = JSON.parse(window.localStorage.getItem('user'))
  return user?.user ? user?.user : null
}


const AuthenticationStore = {
  state: {
    user: storedUser(),
    permissions: []
  },
  getters,
  mutations,
  actions
}

export default AuthenticationStore
